/**
* @file 运营中心-旅游包车订单
* */
<template>
  <div id="order">
    <el-radio-group v-model="tabAction" style="margin-bottom: 15px">
      <el-radio-button label="all">全部</el-radio-button>
      <el-radio-button v-for="item in $const.CZHITCHHIKING" :key="item.value" :label="item.value">
        {{ item.label }}
      </el-radio-button>
    </el-radio-group>

    <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns"
      excel-type="AirportOrder" labelWidth="135" :columnsSettingShow="true">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" v-if="[5, 10].includes(row.status)"
              @click="actionFn({ type: 'cancel', row: row })">取消
            </el-button>
            <div v-if="![5, 10].includes(row.status)">-</div>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="['created', 'finishTime',].includes(item.prop)">
          {{ row[item.prop] | filterTime }}
        </template>

        <template v-else-if="item.prop == 'orderNo'">
          <span class="link" @click="actionFn({ type: 'look', row: row })" @dblclick="$utils.dblclickCopy">{{
            row[item.prop] }}</span>
        </template>

        <template v-else-if="['customerPhone', 'driverName', 'driverPhone'].includes(item.prop)">
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] || '-' }}</span>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>

        <template v-else-if="item.prop === 'startCity'">
          <div>{{ row.startPointName }}</div>
          <div style="color: #999">{{ row.startCity }}{{ row.startDistrict }}</div>
        </template>
        <template v-else-if="item.prop === 'endCity'">
          <div>{{ row.endPointName }}</div>
          <div style="color: #999">{{ row.endCity }}{{ row.endDistrict }}</div>
        </template>

        <template v-else-if="item.prop == 'status'">
          <span v-if="row.status == 5 && !row.dispatchAccountName">新订单</span>
          <span v-else>{{ row.status | filterConst("CZHITCHHIKINGDAN") }}</span>
        </template>
        <template v-else-if="item.prop == 'seatType'">
          {{ row.seatType | filterConst("SEATTYPE") }}
        </template>

        <template
          v-else-if="['amount', 'serviceFee', 'driverAmount', 'dispatchAmount', 'platformAmount'].includes(item.prop)">
          <span class="util-money">￥ {{ row[item.prop] || 0 }}</span>
        </template>

        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-drawer :visible.sync="show" destroy-on-close :close-on-click-modal="false" :before-close="handClose">
      <hitchhikingDetails @handClose="handClose" v-if="show" :rowData="rowData"></hitchhikingDetails>
    </el-drawer>
    <el-dialog title="取消订单" :before-close="handClose" :visible.sync="showCancel" destroy-on-close
      :wrapperClosable="false" width="500px">
      <hitchhikingCancel @handClose="handClose" :rowData="rowData" v-if="showCancel"></hitchhikingCancel>
    </el-dialog>
  </div>
</template>

<script>
import hitchhikingDetails from "./components/hitchhikingDetails.vue";
import hitchhikingCancel from "./components/hitchhikingCancel.vue";

export default {
  name: "order",
  components: {
    hitchhikingDetails,
    hitchhikingCancel,
  },
  data() {
    return {
      tabAction: "all",
      loading: false,
      refundFee: null,
      refundState: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/order",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "orderNo", name: "订单号", value: "" },
          {
            type: "select",
            field: "seatType",
            name: "订单类型",
            value: "",
            option: this.$const.SEATTYPE,
          },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          {
            type: "input",
            field: "customerPhone",
            name: "乘客手机号",
            value: "",
          },
          {
            type: "select",
            field: "payChannel",
            name: "支付方式",
            value: "",
            option: this.$const.PAYTYPE,
          },
          {
            type: "datetime",
            field: "reachTime",
            dateProp: { start: "startTime", end: "endTime" },
            name: "下单时间",
            value: [],
          },
          {
            type: "datetime",
            field: "finishTime",
            dateProp: { start: "startFinishTime", end: "endFinishTime" },
            name: "完成时间",
            value: [],
          },
        ],
      },
      // 表头
      columns: [
        { prop: "orderNo", label: "订单号", minWidth: 190 },
        { prop: "startCity", label: "出发地", minWidth: 200 },
        { prop: "endCity", label: "目的地", minWidth: 200 },
        { prop: "status", label: "订单状态", minWidth: 70 },

        { prop: "created", label: "下单时间", minWidth: 120 },
        { prop: "finishTime", label: "完成/取消时间", minWidth: 120 },
        { prop: "customerPhone", label: "乘客电话", minWidth: 100 },
        { prop: "seatType", label: "订单类型", minWidth: 70 },
        { prop: "passengerNum", label: "乘客数", minWidth: 60 },
        { prop: "licenseNo", label: "车辆号牌", minWidth: 80 },
        { prop: "driverName", label: "司机姓名", minWidth: 80 },
        { prop: "driverPhone", label: "司机电话", minWidth: 100 },
        { prop: "amount", label: "订单金额", minWidth: 100 },
        { prop: "serviceFee", label: "信息费", minWidth: 100 },
        { prop: "driverAmount", label: "司机收入", minWidth: 90 },
        { prop: "dispatchAmount", label: "业务收入", minWidth: 90 },
        { prop: "platformAmount", label: "平台收入", minWidth: 90 },
        { prop: "createdAccountName", label: "下单人", minWidth: 100 },
        { prop: "dispatchAccountName", label: "调度员", minWidth: 100 },
        { prop: "payChannel", label: "支付方式", minWidth: 80 },
        { prop: "remark", label: "备注", minWidth: 150 },
      ],
      show: false,
      showCancel: false,
      rowData: {},
      clickTimeout: null,
      dialogTableVisible: false,
    };
  },
  watch: {
    tabAction(val) {
      this.customOptions.params.page = 1;
      this.customOptions.params.statusList = val != "all" ? val : null;
      this.$refs.customTable.listFn();
    },
  },
  methods: {
    dialogClose() {
      this.dialogTableVisible = false;
    },
    async assignFn(row) {
      const url = "/api/v1/manage/order/hitchRide/assign/again";
      const params = {
        id: this.rowData.id,
        vehicleId: row.vehicleId,
        driverId: row.driverId,
      };
      const { code } = await this.$axios.post(url, params);

      if (code === 1) {
        this.$message.success("订单改派成功");
        this.dialogTableVisible = false;
        this.$refs.customTable.listFn();
      }
    },
    actionFn({ type, row }) {
      clearTimeout(this.clickTimeout);
      this.clickTimeout = setTimeout(() => {
        switch (type) {
          case "look":
            this.rowData = row;
            this.show = true;
            break;
          case "cancel":
            this.rowData = row;
            this.showCancel = true;
            break;
          case "reassignment":
            this.rowData = { ...row };
            this.dialogTableVisible = true;
            break;
        }
      }, 200);
    },
    /**
     * 状态改变
     */

    handClose() {
      this.rowData = {};
      this.show = false;
      this.showCancel = false;
      this.$refs.customTable.listFn();
    },
  },
  created() {
    if (this.$route.query.status) {
      this.customOptions.params.statusList = this.$route.query.status;
      this.tabAction = this.customOptions.params.statusList;
    }
  },
};
</script>

<style scoped lang="less">
#order {
  .dialog_tips {
    color: red;
    margin: 10px 0 5px;
  }

  .result-dialog {
    .content {
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      text-align: center;
      width: 100%;

      .time {
        margin: 10px 0;
      }

      .tips {
        font-size: 14px;
      }
    }

    .btn {
      width: 100%;
      margin-top: 16px;
    }

    /deep/ .el-dialog__body {
      padding: 0 20px 20px !important;
    }
  }

  /deep/ .el-drawer {
    width: 70% !important;
    overflow-x: hidden;
  }

  .el-radio-group {
    .el-radio-button__inner {
      /*border-radius: 0;*/
    }
  }
}
</style>
